<template>
	<ClientOnly>
		<!-- /upitnik/upitnik-zadovoljstva/?webshoporder_code=  &webshoporder_id=   -->
		<SweepstakePageCustom v-slot="{page}" @load="onPageLoad">
			<div class="sw-intro">
				<div class="sw-wrapper">
					<CmsBreadcrumbs v-if="page?.breadcrumbs" :items="page.breadcrumbs" />
					<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
					<div v-if="page?.datetime_active_from" class="sw-date">
						<BaseCmsLabel code="active_from" tag="span" />
						<template v-if="page?.datetime_active_from"> od <strong><BaseUtilsFormatDate :date="page.datetime_active_from" format="DD.MM.YYYY." /></strong></template>
						<template v-if="page?.datetime_active_to"> od <strong><BaseUtilsFormatDate :date="page.datetime_active_to" format="DD.MM.YYYY." /></strong></template>
					</div>
				</div>
			</div>

			<div class="sw-main">
				<div class="sw-wrapper">
					<div class="cms-content sw-content" v-if="page?.content" v-html="page.content" v-interpolation />

					<div v-if="successValue" class="global-success" data-scroll-to-success><BaseCmsLabel :code="successValue" tag="span" /></div>				
					<BaseForm v-else-if="page?.can_vote" v-slot="{errors}" @submit="onSubmit">
						<BaseCmsLabel code="sw_form_main_title" class="sw-form-main-title" tag="div" />

						<template v-if="Object.keys(errors)?.length">
							<BaseCmsLabel tag="div" class="global-error" code="form_validation_error" data-scroll-to-error />
						</template>
						<template v-if="errorValue">
							<BaseCmsLabel tag="div" class="global-error" :code="errorValue" data-scroll-to-error />
						</template>
						
						<div v-if="productsForm.length" class="sw-products">
							<div class="sw-product form-animated-label" v-for="(product, index) in productsForm" :key="index">
								<div class="sw-product-info">
									<div class="sw-product-image" v-if="product?.main_image_upload_path"><BaseUiImage :src="product.main_image_upload_path" /></div>
									<div class="sw-product-title">{{product.title}}</div>
								</div>
								

								<template v-for="field in product.formFields" :key="field.name">
									<BaseFormField v-if="field.type != 'hidden'" :item="field" v-slot="{errorMessage, value, isTouched, floatingLabel}">
										<div class="field field-images" v-if="field.name.includes('image_1')">
											<input type="file" :name="field.name" :id="field.name" multiple ref="imageInput" @change="(event) => handleImageChange(event, product.product_id)">
											<label :for="field.name"><BaseCmsLabel code="field_add_photos" /><BaseCmsLabel code="field_add_photos_max" tag="span" /></label>
											<BaseCmsLabel code="field_add_photos_max_mb" class="sweepstake-max-note" tag="span" />

											<span class="uploaded-images" v-if="images[product.product_id] && images[product.product_id].length">
												<span class="uploaded-images-items">
													<div v-for="(image, index) in images[product.product_id]" :key="index">{{image.name}}</div>
												</span>
												<span class="uploaded-delete" @click="clearImages(product.product_id, index)"><BaseCmsLabel code="delete_images" /></span>
											</span>
										</div>
										<div v-else-if="field.name.includes('video')" class="sw-product-field field field-video" :class="['field-' + field.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}]">
											<input type="file" :name="field.name" :id="field.name" ref="videoInput" @change="(event) => {videos[product.product_id] = event.target.files?.[0]}">										
											<BaseCmsLabel tag="div" class="sweepstake-max-note" code="field_add_video_max_mb" />
											<BaseCmsLabel tag="label" :for="field.name" code="video" />	

											<div class="uploaded-images" v-if="videos[product.product_id]?.name">
												<span class="uploaded-images-items">
													{{ videos[product.product_id].name }}
												</span>
												<span class="uploaded-delete" @click="clearVideo(product.product_id, index)"><BaseCmsLabel code="delete_video" /></span>
											</div>
										</div>

										<div v-else class="sw-product-field field" :class="['field-' + field.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}, {'field-type-rate': field.type == 'rate'}, {'field-video': field.name.includes('video')}, {'field-textarea': field.type == 'textarea'}]">
											<span v-if="field.type == 'rate'" class="label"><BaseCmsLabel code="your_rate" /></span>
											<BaseFormInput :id="field.name" :name="field.name" />
											<BaseCmsLabel v-if="field.type == 'textarea'" tag="label" :for="field.name" code="inquiry_message" />
											<span class="field_error error" v-show="errorMessage" v-html="errorMessage" />
										</div>
									</BaseFormField>
								</template>
							</div>
						</div>

						<div class="sweepstake-form form-animated-label">
							<BaseCmsLabel code="sweepstake_form_title" class="sweepstake-form-title" tag="div"/>

							<template v-for="(field, index) in fields" :key="field.name">
								<BaseFormField :item="field" v-slot="{errorMessage, value, isTouched, floatingLabel}">
									<div v-if="field.title" class="sweepstake-question-title">{{ field.title }}<span v-if="field.validation.length"> *</span></div>
									<div class="sweepstake-field field" :class="['field-' + field.id, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value},{'last': index === fields.length - 1}, {'field-textarea': field.type == 'textarea'}]">
										<div v-if="field.tips" class="sweepstake-note" v-html="field.tips"></div>
										<BaseFormInput />
										<BaseCmsLabel v-if="field.type == 'textarea'" tag="label" :for="field.id" code="inquiry_message" />
										<span class="error" v-show="errorMessage" v-html="errorMessage" />
									</div>
								</BaseFormField>
							</template>
						
							<template v-for="field in userFields" :key="field.name">
								<BaseFormField :item="field" v-slot="{errorMessage, value, isTouched, floatingLabel}">
									<div class="field" :class="['field-' + field.name, {'ffl-floated': floatingLabel}, {'err': errorMessage}, {'success': !errorMessage && isTouched && value}]">
										<BaseFormInput />
										<BaseCmsLabel tag="label" :for="field.name" :code="'sweepstake_'+field.name" />
										<span class="error" v-show="errorMessage" v-html="errorMessage" />
									</div>
								</BaseFormField>
							</template>

							<div class="sweepstake-btn-section">
								<button type="submit" class="btn btn-sweepstake" :class="{'loading': loadingValue}">
									<UiLoader v-if="loadingValue" /><BaseCmsLabel code="vote" tag="span" />
								</button>
								<BaseCmsLabel code="required_field" class="req-fields" tag="div" />
							</div>
						</div>
					</BaseForm>
					<template v-else>
						<BaseCmsLabel v-if="!page?.vote_url" class="votes-finish global-warning" code="votes_closed" />
						<BaseCmsLabel v-else-if="!page?.can_vote" class="votes-finish global-success" code="already_vote" />
					</template>
				</div>
			</div>
		</SweepstakePageCustom>
	</ClientOnly>
</template>

<script setup>
	const labels = useLabels();
	const endpoints = useEndpoints();
	let fields = ref(null);
	let userFields = ref([]);
	let loadingValue = ref(false);
	let successValue = ref(null);
	let errorValue = ref(null);
	let pageCode = ref('');
	const nuxtApp = useNuxtApp();
	const route = nuxtApp._route;
	const {fetchOrder} = useWebshop();
	const order = ref(null);

	const productsForm = ref([]);

	const images = ref({})
	const imageInput = ref({})
	const videos = ref({})
	const videoInput = ref({})

	function handleImageChange(event, productId) {
		const selectedImages = Array.from(event.target.files)		
		images.value[productId] = selectedImages.slice(0, 5)
	}

	function clearImages(productId, index) {
		images.value[productId] = []
		imageInput.value[index].value = ''
	}

	function clearVideo(productId, index) {
		videos.value[productId] = ''	
		videoInput.value[index].value = ''
	}	

	async function onPageLoad(item) {
		if(!item) return;

		if(item) {
			pageCode.value = item?.code;
			if(route?.query?.webshoporder_code && route?.query?.webshoporder_id){
				order.value = await fetchOrder({code: `${route.query.webshoporder_id}-${route.query.webshoporder_code}`});
				console.log(order.value);				
			}			

			if(item.items_form?.length && item.items.length){
				const fieldsByProductId = {};
				let pid = null;

				item.items_form.forEach(field => {
					if (field.name === 'id') {
						pid = field.value.match(/catalogproduct-(\d+)-hr/)?.[1];
						if (pid) fieldsByProductId[pid] = [];
						return;
					}

					if (pid) {
						if (field.name === 'message') {
							field.name = 'comment';
						}

						if (field.name === 'rate') {
							field.type = 'rate';
						}

						if (['comment', 'rate'].includes(field.name)) {
							field.validation.push({type: 'not_empty', value: null, error: 'error_not_empty'});
						}

						field.name = `${field.name}-${pid}`;

						if (field.name.startsWith('image_1') || !field.name.includes('image')) {
							fieldsByProductId[pid].push(field);
						}
					}
				});

				productsForm.value = item.items.map(product => ({
					...product,
					formFields: fieldsByProductId[product.product_id] || []
				}));
			}
		

			//fields
			const questionsArray = Object.values(item?.questions);

			fields.value = questionsArray
			.sort((a, b) => (a.position || 0) - (b.position || 0))
			.map(obj => {
				let fieldType = obj.type;

				if (obj.type === "selectm") {
					fieldType = "checkbox";
				} else if (obj.type === "text") {
					fieldType = "textarea";
				} else if (obj.type === "") {
					fieldType = "radio";
				}

				let optionsValue = null;
				if(obj?.answers_option){
					optionsValue = Object.entries(obj.answers_option).map(([key, title]) => ({
						title,
						key: parseInt(key),
						selected: false,
					}));
				}

				return {
					id: obj.id,
					name: 'question_' + obj.id,
					value: '',
					type: fieldType,
					title: obj.title || null,
					description: obj.tips || null,
					related_field: null,
					opens_fields: null,
					extra_info: null,
					options: optionsValue,
					error_text: obj.error_text || null,
					validation: obj.requested == 1 ? [{"type": "not_empty", "value": null, "error": "error_not_empty"}] : []
				};
			});

			//user fields
			if(item?.user_form?.length){
				item.user_form.forEach(field => {
					if(field.name == 'gdpr_accept') {
						field.validation = [{type: 'not_empty', value: null, error: 'error_not_empty'}];
					} 
					userFields.value.push(field);
				})
			}
			

		}
	}

	//submit
	async function onSubmit({values, actions}) {	
		values.email = order.value?.data?.customer?.email ? order.value.data.customer.email : '';
		values.first_name = order.value?.data?.customer?.first_name ? order.value.data.customer.first_name : '';
		values.last_name = order.value?.data?.customer?.last_name ? order.value.data.customer.last_name : '';
		values.phone = order.value?.data?.customer?.phone ? order.value.data.customer.phone : '';
		values.webshoporder_code = order.value?.data?.cart?.order_code ? order.value.data.cart.order_code : '';
		
		const formData = new FormData()

		formData.append('page_code', pageCode.value)

		Object.entries(values).forEach(([key, value]) => {
			if (Array.isArray(value)) {
				value.forEach((v, index) => {
					formData.append(`${key}[${index}]`, v)
				})
			} 
			else {
				formData.append(key, value)
			}
		})

		Object.entries(images.value).forEach(([productId, images]) => {
			images.forEach((file, index) => {
				const fieldName = `image_${index + 1}-${productId}`
				formData.append(fieldName, file)
			})
		})
		
		Object.entries(videos.value).forEach(([productId, video]) => {
			if(video){
				const fieldName = `video-${productId}`
				formData.append(fieldName, video)
			}
		})		

		/*
		for (let [key, value] of formData.entries()) {
			console.log(key, value)
		}*/

		loadingValue.value = true;

		await useApi(`${endpoints.get('_post_hapi_sweepstake_participant')}`, {
			method: 'POST',
			body: formData
		}, {appendLang: false}).then(async (res) => {
			errorValue.value = null;
			if(res.success) {
				successValue.value = res?.data?.label_name;
				if(res?.data?.redirect_url_without_domain) {
					navigateTo({path: res.data.redirect_url_without_domain});
				} else {
					await nextTick();

					const successEl = document.querySelector('.global-success');
					if (successEl) {
						successEl.scrollIntoView({behavior: 'smooth'});
					}
				}
			} else {
				errorValue.value = res?.data?.label_name;

				await nextTick();

				const errorEl = document.querySelector('.global-error');
				if (errorEl) {
					errorEl.scrollIntoView({behavior: 'smooth'});
				}

				// set field errors if response contains api errors
				if (res?.data?.errors?.length) {
					res.data.errors.forEach(error => {
						actions.setFieldError(error.field, labels.get(error.error, error.error));
					});

					await nextTick();
					const errorEl = document.querySelector('.global-error');
					if (errorEl) {
						errorEl.scrollIntoView({behavior: 'smooth'});
					}

					return res;
				}
			}
		});

		loadingValue.value = false;
	}
</script>

<style lang="less" scoped>
	.sw-intro{
		padding: 35px 0 24px; position: relative; text-align: center; border-top: 1px solid var(--borderColor);
		@media (max-width: @t){padding: 30px 0 20px;}
		@media (max-width: @m){border-top: 0; padding: 24px 0 12px; text-align: left;}
	}
	.sw-wrapper{
		max-width: 920px; margin: auto;
		@media (max-width: @t){width: auto; max-width: 100%; margin: 0 30px;}
		@media (max-width: @tp){margin: 0 15px;}
	}
	h1{font-weight: bold;}
	.sw-date{
		font-size: 20px; line-height: 26px; padding-top: 5px;
		@media (max-width: @t){font-size: 18px; line-height: 24px;}
		@media (max-width: @m){font-size: 16px; line-height: 22px;}
	}

	.sw-main{
		padding-bottom: 104px;
		@media (max-width: @t){padding-bottom: 80px;}
		@media (max-width: @m){padding-bottom: 40px;}
	}
	.sw-content{
		padding: 0;
		:deep(p){padding-bottom: 10px;}
		:deep(strong){color: var(--primaryColor);}
	}
	.sw-form-main-title{
		font-size: 24px; line-height: 32px; font-weight: bold; padding: 16px 0;
		@media (max-width: @t){font-size: 20px; line-height: 26px; padding: 12px 0;}
		@media (max-width: @m){font-size: 18px; line-height: 23px;}
	}

	//PRODUCTS
	.sw-product{
		display: flex; flex-wrap: wrap; background: #F5F5F5; margin: 0 0 24px; padding: 32px; column-gap: 10px;
		@media (max-width: @t){margin-bottom: 20px; padding: 25px;}
		@media (max-width: @m){flex-wrap: nowrap; flex-flow: column; margin-bottom: 16px; padding: 16px; }
	}
	.sw-product-info{
		flex: 1 1 calc(~"50% - 5px"); display: flex; align-items: center; margin-bottom: 20px;
		@media (max-width: @t){margin-bottom: 16px;}
	}
	.sw-product-image{
		display: block; width: auto; height: auto;
		:deep(img){
			display: block; max-height: 70px; max-width: 80px; width: auto; height: auto;
			@media (max-width: @m){max-width: 64px; max-height: 55px;}
		}
	}
	.sw-product-title{
		font-size: 18px; line-height: 23px; padding-left: 24px; padding-right: 10px;
		@media (max-width: @t){padding-left: 18px;}
		@media (max-width: @m){font-size: 16px; padding-left: 12px; padding-right: 0;}
	}
	.sw-product-field{flex: 1 1 calc(~"50% - 5px"); justify-content: center; align-items: center;}
	.field-type-rate{
		display: flex; flex-wrap: wrap; align-items: center; width: 100%; padding-bottom: 0!important; margin-bottom: 20px;
		.label{font-size: 18px; display: inline-block; vertical-align: top; padding-right: 16px;}
		.error{width: 100%; text-align: center; padding-top: 0; padding-left: 0;}
		@media (max-width: @m){
			margin-bottom: 9px; justify-content: flex-start; padding-left: 16px;
			.label{font-size: 16px; padding-right: 12px;}
			.error{text-align: left; padding-left: 2px;}
		}
	}
	:deep(.form-rate-item){
		line-height: 25px; margin-bottom: 2px;
		input[type=radio]+label{
			padding: 0; font-size: 0!important; width: 25px; height: 25px; min-height: 25px; margin: 4px 2px 15px;
			&:before{display: none;}
			&:after{ .pseudo(25px,25px); background: url(assets/images/icons/stars.svg) no-repeat; background-size: contain; top: 0; left: 0; visibility: visible; opacity: 1;}
		}
		&.active input[type=radio]+label:after, &.active-hover input[type=radio]+label:after{background: url(assets/images/icons/stars-yellow2.svg) no-repeat; background-size: contain;}
		@media (max-width: @m){
			line-height: 20px; margin-bottom: 0;
			input[type=radio]+label{
				width: 22px; height: 22px; min-height: 22px; margin: 0;
				&:before{display: none;}
				&:after{width: 22px; height: 22px; top: -8px;}
			}
		}
	}
	.field-images{
		flex-grow: 0; flex-shrink: 0; width: calc(~"50% - 5px"); position: relative;
		label{
			position: absolute; width: calc(~"100% - 2px"); height: 58px; top: 2px; left: 1px!important; background: #fff; display: flex; align-items: center; padding: 0 25px 0 56px; font-size: 18px; line-height: 24px; justify-content: space-between;
			span{font-size: 14px; line-height: 18px; color: var(--textColor); opacity: .6;}
			&:before{.pseudo(24px,21px); .icon-images(); font: 21px/21px var(--fonti); left: 25px;}
		}
		@media (max-width: @t){
			label{height: 48px; top: 4px; padding-right: 20px;}
		}
		@media (max-width: @m){
			width: 100%;
			input{height: 50px;}
			label{
				height: 48px; top: 5px!important; left: 1px!important; padding: 0 16px 0 44px!important; font-size: 16px; line-height: 22px;
				&:before{width: 18px; height: 18px; font-size: 18px; line-height: 18px; left: 16px;}
			}
		}
	}
	.sweepstake-max-note{
		position: absolute; top: 62px; display: block; width: 100%; text-align: right; font-size: 12px; line-height: 18px; color: var(--textColor); opacity: .6; padding: 0 25px;
		@media (max-width: @t){padding-right: 20px; top: 52px;}
		@media (max-width: @m){padding: 2px 16px 0;}
	}
	.uploaded-images{
		position: relative; display: flex; flex-flow: column; align-items: flex-start; justify-content: flex-start; padding: 15px 25px 20px; gap: 14px;
		@media (max-width: @m){padding: 12px 16px 10px; gap: 10px;}
	}
	.uploaded-images-items{
		display: flex; flex-flow: column; align-items: flex-start; justify-content: flex-start; font-size: 14px; line-height: 18px; text-decoration: underline; text-underline-offset: 2px;
		@media (max-width: @m){font-size: 12px; line-height: 16px;}
	}
	.uploaded-delete{
		position: relative; font-size: 12px; line-height: 17px; padding-left: 15px; cursor: pointer; text-transform: uppercase; color: var(--red); text-decoration: underline; text-underline-offset: 3px; font-weight: 900;
		&:before{.pseudo(auto,auto); .icon-close; font: 10px/10px var(--fonti);  top: 4px; left: 0;}
		&:hover{text-decoration: none;}
	}
	:deep(.field-video){
		flex-grow: 0; flex-shrink: 0; width: calc(~"50% - 5px"); position: relative;
		label{
			position: absolute; width: calc(~"100% - 2px"); height: 58px; top: 2px; left: 1px!important; background: #fff; display: flex; align-items: center; padding: 0 25px 0 56px; font-size: 18px; line-height: 23px; justify-content: space-between;
			&:before{.pseudo(21px,24px); .icon-video(); font: 23px/23px var(--fonti); left: 26px;}
		}
		@media (max-width: @t){
			label{height: 48px; top: 4px; padding-right: 20px;}
		}
		@media (max-width: @m){
			width: 100%; margin-top: 20px;
			input{height: 50px;}
			label{
				height: 48px; top: 5px!important; left: 1px!important; padding: 0 16px 0 44px!important; font-size: 16px; line-height: 22px;
				span{font-size: 11px; line-height: 15px;}
				&:before{width: 19px; height: 19px; font-size: 19px; line-height: 19px; left: 16px;}
			}
		}
	}
	.field-textarea{
		margin-top: 30px;
		:deep(textarea){background: white;}
		@media (max-width: @m){
			margin-top: 25px;
			label{font-size: 16px;}
			&.ffl-floated label{font-size: 12px;}
		}
	}


	.sweepstake-form-title{
		font-size: 30px; line-height: 40px; font-weight: bold; padding: 24px 0 16px;
		@media (max-width: @t){font-size: 26px; line-height: 36px; padding: 8px 0 12px;}
		@media (max-width: @m){font-size: 24px; line-height: 32px;}
	}
	.sweepstake-field{
		display: flex; flex-wrap: wrap; padding-bottom: 40px; column-gap: 32px;
		:deep(span) {
			input[type=radio] + label:before{width: 22px; height: 22px;}
			input[type=checkbox] + label{padding-top: 2px;}
		}
		&.last{
			padding-bottom: 12px; margin: 0!important;
			.error{padding-left: 25px;}
		}
		.error{width: 100%; padding-left: 34px;}
		@media (max-width: @t){
			padding-bottom: 32px; column-gap: 26px;
			:deep(span) {
				input[type=radio] + label:before{width: 20px; height: 20px;}
				input[type=checkbox] + label{padding-top: 1px;}
			}
		}
		@media (max-width: @m){
			padding-bottom: 24px; flex-wrap: nowrap; flex-flow: column;
			:deep(span) {
				input[type=checkbox] + label{
					padding-top: 0px;
					&:before{margin-top: 2px;}
				}
			}
			&.last{
				.error{padding-left: 15px;}
			}
			.error{width: 100%; padding-left: 30px;}
		}
	}
	.sweepstake-question-title{
		font-size: 20px; line-height: 26px; font-weight: bold; padding-bottom: 16px; width: 100%;
		@media (max-width: @t){font-size: 18px; line-height: 23px; padding-bottom: 12px;}
		@media (max-width: @m){padding-bottom: 8px;}
	}

	.field-gdpr_accept{
		.error{padding-left: 32px;}
		@media (max-width: @m){
			input[type=checkbox] + label{
				padding-top: 0px;
				&:before{margin-top: 2px;}
			}
		}
	}

	.sweepstake-btn-section{
		margin-top: 32px; position: relative; display: flex; align-items: center;
		.btn-sweepstake{margin: 0;}
		@media (max-width: @t){margin-top: 24px;}
		@media (max-width: @m){
			margin-top: 16px; flex-flow: column; align-items: unset;
			.btn-sweepstake{height: 50px; font-size: 16px;}
		}
	}
	.req-fields{
		display: flex; flex-grow: 1; flex-flow: column; font-size: 16px; line-height: 22px; padding-bottom: 0; margin: 0; padding-left: 38px; color: var(--textColor); font-weight: 500; opacity: 0.5;
		@media (max-width: @m){font-size: 12px; line-height: 16px; padding-left: 0; text-align: center; padding-top: 15px;}
	}
</style>

